import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.incidentResponse || initialState;

export const selectIncidentResponse = createSelector(
  [selectDomain],
  incidentResponseState => incidentResponseState,
);
